var firebaseConfig = {
    apiKey: "AIzaSyDzVFSi-7hj-RnHhaQChDn4DMhjXmXmf1U",
    authDomain: "phography-site.firebaseapp.com",
    projectId: "phography-site",
    storageBucket: "phography-site.appspot.com",
    messagingSenderId: "323316565427",
    appId: "1:323316565427:web:3c31d060be2c9fdaff77c6"
  };


export default firebaseConfig